import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";

const overlayStyles = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.7)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
};

const imgStyles = {
  maxWidth: "50vw",
  maxHeight: "50vh",
  borderRadius: "12px",
  boxShadow: "0 10px 40px rgba(0,0,0,0.4)",
  cursor: "zoom-out",
};

export default function ZoomImage({
  src,
  alt = "",
  thumbnailSrc,
  className = "",
  style = {},
  thumbStyle = {},
  closeOnImageClick = true, // <— nieuw
}) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <>
      <img
        src={thumbnailSrc || src}
        alt={alt}
        className={className}
        style={{ cursor: "zoom-in", ...style, ...thumbStyle }}
        onClick={() => setOpen(true)}
        loading="lazy"
      />
      {open &&
        createPortal(
          <div
            style={overlayStyles}
            onClick={() => setOpen(false)} // klik buiten de image -> sluiten
            role="dialog"
            aria-modal="true"
          >
            <img
              src={src}
              alt={alt}
              style={imgStyles}
              onClick={(e) => {
                e.stopPropagation();          // voorkom dubbele trigger
                if (closeOnImageClick) setOpen(false); // klik op image -> sluiten
              }}
            />
          </div>,
          document.body
        )}
    </>
  );
}
